
import { IOneMessageDialogJson, IOneMessageJson } from "../../../../nodeserver/structs/database.js";
import { ServerApi } from "../api.js";
import { handleFetchError } from "../helpers/functions.js";
import { Websocket } from "../websocket.js";
import JSX from "../helpers/react.js";
import { OneDialog } from "./one-dialog.js";
class Messages {
    private readonly dialogsContainer: JQuery = $('.dialogs-container').on('scroll', this.onScrollDialogs.bind(this));
    public readonly messagesContainer: JQuery = $('.messenger .messages-container');
    messagesData: JQuery = $('.messages-data');
    private fullyLoadedDialogs: boolean = false;
    public dialogs: OneDialog[] = [];
    private _loadingDialogs: boolean = false;

    public get selectedDialog(): OneDialog | null {
        return Messages.Instance?.dialogs?.find(e => e.selected) ?? null;
    }

    public constructor() {
        if (this.dialogsContainer[0])
            this.loadMessagesDialogs().catch(console.error);
    }

    public async showMessagesTab(user_id: number) {
        this.dialogs.filter(e => e.selected).forEach(d => d.selected = false);
        Messages.showHideMessagesContainer(true);
        this.messagesData.find('.nothing-selected').css('display', '').html(<i className="loading large"/>);
        this.messagesData.find('.messenger').css('display', 'none');
        try {
            let dialog: OneDialog = this.dialogs.find(e => e.data.user_id == user_id) ?? ((() => {
                throw "Dialog not found"
            })());
            dialog.selected = true;
            try {
                let messages: IOneMessageJson[] = [];
                if (!dialog.messages.length && !dialog.loading && !dialog.fullLoaded) {
                    dialog.loading = true;
                    messages = await this.loadMessagesJson(user_id);
                }
                this.messagesData.find('.nothing-selected').css('display', 'none');
                this.messagesData.find('.messenger').css('display', '');

                for (let i of messages) dialog.addMessage(i);
                dialog.fullLoaded ||= messages.length < 20;
                if (dialog.unreadCount > 0 && dialog.messages[dialog.messages.length - 1]?.message?.from_id == user_id)
                    Websocket.Instance.readMessages(user_id);

            } finally {
                dialog.loading = false;
            }

        } catch (e) {
            handleFetchError(e);
            this.messagesData.find('.nothing-selected').css('display', '').html(<div>В процессе загрузки данных
                произошла ошибка</div>)
                .append(<button className="main-button neutral"
                                onClick={this.showMessagesTab.bind(this, user_id)}>Попробовать еще раз</button>);
            this.messagesData.find('.messenger').css('display', 'none');
        }
    }

    private get messagesDialogsOffset() {
        //TODO: if we loaded messages with getAlso - this parameter should be -1
        return this.dialogsContainer.find('.message-dialog').length;
    }

    private get messagesOffset() {
        return this.messagesContainer.find('.messages-with-user.shown .one-message:first').data('id') || 0;
    }

    private async loadMessagesDialogs(start = true) {
        try {
            const match = location.hash.match(/messages(-?\d+)/);
            let selectedUid: number | null = match && start ? +match[1] : null;

            const dialogs: IOneMessageDialogJson[] = await this.loadMessagesDialogsJson(selectedUid);
            this.dialogsContainer.children('*:not(.message-dialog)').remove();
            for (let dialog of dialogs) {
                this.dialogs.push(OneDialog.create(dialog));
            }
            if (selectedUid) await this.showMessagesTab(selectedUid);
            this.fullyLoadedDialogs = dialogs.length < 20;
        } catch (e) {
            handleFetchError(e);
            this.dialogsContainer.children('*:not(.message-dialog)').remove();
            this.dialogsContainer[0].append(
                <div>В процессе загрузки данных произошла ошибка.</div>,
                <button className="main-button neutral" onClick={() => this.loadMessagesDialogs()}>Попробовать еще
                    раз</button>
            );
            console.error(e);
        }
    }

    private onScrollDialogs() {
        if (this.dialogsContainer.scrollTop()! > (+this.dialogsContainer.prop('scrollHeight')! - this.dialogsContainer.prop('clientHeight')) - 300 && !this.fullyLoadedDialogs) {
            if (!this._loadingDialogs)
                this.loadMessagesDialogs(false).catch(console.error);
        }
    }

    private async loadMessagesDialogsJson(uid: number | null = null): Promise<IOneMessageDialogJson[]> {
        this._loadingDialogs = true;
        try {
            const ans = typeof uid == "number" ?
                (await ServerApi.messages.getDialogs(this.messagesDialogsOffset, uid)) :
                (await ServerApi.messages.getDialogs(this.messagesDialogsOffset));
            return ans;
        } finally {
            this._loadingDialogs = false;
        }
    }

    private async loadMessagesJson(userId: number): Promise<IOneMessageJson[]> {
        return ServerApi.messages.getMessages(
            userId,
            userId == 0 ? ($('.chatter .one-message:first[data-chat-id]').data('id') ?? 0) : this.messagesOffset
        )
    }

    public async loadMoreMessages(dialog: OneDialog) {
        if (dialog.loading || dialog.fullLoaded) return false;
        dialog.loading = true;
        try {
            const messages: IOneMessageJson[] = await this.loadMessagesJson(dialog.data.user_id);
            for (let i of messages)
                dialog.addMessage(i);
            dialog.fullLoaded = messages.length < 20;
        } catch (e) {
            handleFetchError(e);
        } finally {
            dialog.loading = false;
        }
    }

    public static Instance: Messages | undefined;

    /**
     * Show/hide messages container for mobile devices
     * Show=true -> show messages
     * Show=false -> show dialogs
     */
    public static showHideMessagesContainer(show: boolean) {
        const closeIcon = $('.close-chat-icon'),
            dialogs = $('.messages-main-user'),
            messages = $('.messages-data');
        if (show) {
            messages.addClass('active').removeClass('animating');
            closeIcon.addClass('active').removeClass('animating');
            dialogs.addClass('animating');
            setTimeout(() => {
                dialogs.removeClass('active');
            }, 300)
        } else {
            dialogs.addClass('active').removeClass('animating');
            messages.addClass('animating');
            closeIcon.addClass('animating');
            setTimeout(() => {
                messages.removeClass('active');
                closeIcon.removeClass('active');
            }, 300);
        }
    }
}
// @ts-ignore
window['Messages'] = Messages;
$(() => {
    $('.message-textarea.chat-message').val(localStorage.message_0 ?? '');
});

$(function () {
    Messages.Instance = new Messages;
})

export {
    

    Messages
    
}
